'use strict';

var Reflux = require('reflux');

/* Actions */
var ModuleConnectionActions = require('actions/module-connection');
var ModuleActions = require('actions/module');
var ProjectActions = require('actions/project');

/* Api */
var ModuleConnectionApi = require('api/module-connection');

/* Stores */
var ModuleStore = require('./module');

var ModuleConnectionStore = Reflux.createStore({

  listenables: [ModuleConnectionActions],

  init: function init() {
    var store = this;

    store.listenTo(ProjectActions.leave, 'onLeaveProject');
    store.listenTo(ModuleActions.selectModule, 'onSelectModule');
    store.listenTo(ModuleActions.deleteSelectedModules, 'onDeleteSelectedModules');
    store.joinTrailing(ModuleActions.loadModulesForProject, ModuleStore, 'onModulesLoaded');

    store.connections = [];
  },

  getInitialState: function getInitialState() {
    var store = this;
    var connections = store.connections;

    return connections;
  },

  onStartConnectionAtOutput: function onStartConnectionAtOutput(projectId, moduleId, outputName) {
    var store = this;

    var module = ModuleStore.find(moduleId);

    var index = 0;
    var output = module.moduleType.outputs.find(function (output) {
      index++;
      return output.name === outputName;
    });

    store.dragging = true;
    store.outputModule = module;
    store.outputName = outputName;
    store.outputIndex = index;

    store.trigger(store.connections);
  },

  onUpdateDrag: function onUpdateDrag(x, y) {
    var store = this;

    store.position = { x: x, y: y };

    store.trigger(store.connections);
  },

  onStopDragging: function onStopDragging() {
    var store = this;
    store.dragging = false;
    store.position = null;
    store.trigger(store.connections);
  },

  onStopConnectionAtInput: function onStopConnectionAtInput(projectId, moduleId, inputName) {
    var store = this;
    var module = ModuleStore.find(moduleId);

    var index = 0;
    var input = module.moduleType.inputs.find(function (input) {
      index++;
      return input.name === inputName;
    });

    store.dragging = false;
    store.position = null;
    store.inputModule = module;
    store.inputName = inputName;
    store.inputIndex = index;

    var connection = {
      project: projectId,
      output: {
        instance: store.outputModule.id,
        name: store.outputName
      },
      input: {
        instance: store.inputModule.id,
        name: store.inputName
      }
    };

    var temporaryConnectionId = Math.round(Math.random() * 10000000000).toString();

    store.connections.push({
      id: temporaryConnectionId,
      output: connection.output,
      input: connection.input
    });

    delete store.inputModule;
    delete store.inputName;
    delete store.inputIndex;
    delete store.outputModule;
    delete store.outputName;
    delete store.outputIndex;

    store.trigger(store.connections);

    ModuleConnectionApi.add(connection).done(function (data) {
      store.connections = store.connections.filter(function (connection) {
        return connection.id !== temporaryConnectionId;
      });
      store.connections.push(data);
    }).always(function () {
      store.trigger(store.connections);
    });
  },

  onLoadModuleConnectionsForProject: function onLoadModuleConnectionsForProject(projectId) {},

  onModulesLoaded: function onModulesLoaded(loadModulesParams) {
    var store = this;

    var projectId = loadModulesParams[0];
    store.projectId = projectId;

    ModuleConnectionApi.load({ projectId: projectId }).done(function (data) {
      store.connections = data;
      store.trigger(store.connections);
    });
  },

  onDeleteSelectedModules: function onDeleteSelectedModules() {
    var store = this;
    var projectId = store.projectId;
    var selectedModuleIds = ModuleStore.modules.filter(function (module) {
      return module.selected;
    }).map(function (module) {
      return module.id;
    });

    store.connections = store.connections.filter(function (connection) {
      return !selectedModuleIds.includes(connection.input.instance) || !selectedModuleIds.includes(connection.output.instance);
    });
    store.trigger(store.connections);
  },

  onSelectConnection: function onSelectConnection(connectionId, modifiers) {
    var store = this;
    var connections = store.connections;

    var _ref = modifiers || {};

    var metaKey = _ref.metaKey;
    var ctrlKey = _ref.ctrlKey;

    var selectMultiple = metaKey || ctrlKey;

    connections.forEach(function (connection) {
      var match = connection.id === connectionId;

      if (selectMultiple) {
        if (match) {
          connection.selected = !connection.selected;
        }
      } else {
        connection.selected = match;
      }
    });

    store.trigger(connections);
  },

  onSelectModule: function onSelectModule() {
    var store = this;
    var connections = store.connections;

    connections.forEach(function (connection) {
      connection.selected = false;
    });

    store.trigger(connections);
  },

  onDeleteSelectedConnections: function onDeleteSelectedConnections() {
    var _this = this;

    var connections = this.connections;

    var selectedIds = connections.filter(function (connection) {
      return connection.selected;
    }).map(function (connection) {
      return connection.id;
    });

    if (!selectedIds.length) {
      return;
    }

    ModuleConnectionApi['delete'](selectedIds).done(function () {
      _this.connections = connections.filter(function (connection) {
        return !connection.selected;
      });
      _this.trigger(_this.connections);
    });
  },

  onLeaveProject: function onLeaveProject() {
    this.connections = [];
    this.trigger(this.connections);
  }

});

module.exports = ModuleConnectionStore;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/stores/module-connection.js
 **/